'use strict';

var _ = require('lodash');
var BookingsIntakeChart = function BookingsIntakeChart(AbstractChart, scalesService, chartGroups, chartStripes, chartXAxis, chartYAxis, chartCircles, chartConstants) {
  var chartParams = require('./Params');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    // chart components
    var groups = chartGroups('offsetDays');
    var xAxisTickValuesHandler = function xAxisTickValuesHandler(data) {
      return _.map(data, 'offsetDays');
    };
    var xAxis = chartXAxis(formatters.xAxisTickFormatter, xAxisTickValuesHandler);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withHorizontalLinesValues([0]);
    yAxisLeft.label('Intake');
    var stripes = chartStripes('data');
    var circles = chartCircles('circles');
    this.render = function (data) {
      this.initChart(data, undefined, chartParams);
      this.scales = scalesService.createPositiveNegativeBarScale(this.params, this.data, 'offsetDays');
      this.callForDataGroup([yAxisLeft, groups, stripes, circles, xAxis], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
BookingsIntakeChart.$inject = ['AbstractChart', 'ScalesService', 'ChartElementsGroup', 'ChartElementsStripes', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsCircles', 'ChartElementsConstants', 'ScalesService'];
module.exports = BookingsIntakeChart;